import React from 'react';

const SvgIconBoating = props => (
  <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
    <defs>
      <path
        id="icon-boating_svg__a"
        d="M18.16 11.255c-.063.03-1.143.848-2.8.848H4.007c-1.231 0-2.34-.7-2.922-1.793L.86 9.414V6.276h.556c1.778 0 3.607.431 5.268 1.297.06.031.125.048.192.048H11a.44.44 0 0 0 .43-.449V3.586h2.278c2.375 0 4.627 1.185 6.05 3.138h-.766a.44.44 0 0 0-.43.448.44.44 0 0 0 .43.449h1.33a8.02 8.02 0 0 1 .705 1.793l-1.367.896c-.515.3-1.012.626-1.5.945M2.463 4.085a.83.83 0 0 1 .713-.186l3.868.807c.4.084.69.453.69.88v1.138h-.758a12.33 12.33 0 0 0-4.828-1.321v-.625a.91.91 0 0 1 .315-.693m19.529 5.69c-.796-4.154-4.29-7.085-8.284-7.085h-1.153L11.385.248a.422.422 0 0 0-.577-.2L8.23 1.391a.458.458 0 0 0-.192.602.421.421 0 0 0 .576.2l2.194-1.144.786 1.64H11a.44.44 0 0 0-.43.448v3.586H8.594V5.585c0-.852-.581-1.591-1.382-1.758L3.345 3.02a1.66 1.66 0 0 0-1.427.371c-.4.342-.629.848-.629 1.387v.601h-.86A.44.44 0 0 0 0 5.828v4.034l.001.024.001.017a.458.458 0 0 0 .02.1C.595 11.797 2.196 13 4.007 13H15.36c1.876 0 3.053-.89 3.257-.985.857-.561 1.743-1.141 2.676-1.547l.443-.192a.454.454 0 0 0 .256-.5"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      transform="translate(0 5)"
      xlinkHref="#icon-boating_svg__a"
    />
  </svg>
);

export default SvgIconBoating;
